import { action } from 'typesafe-actions';
import { CompanyToList } from '../../../model/company';
import { GiroWebappError } from '../../../model/error';
import { MyCompaniesActionTypes } from './types';

export const getMyCompaniesRequest = () => action(MyCompaniesActionTypes.GET_MY_COMPANIES_REQUEST);
export const getMyCompaniesSuccess = (companies: CompanyToList[]) => action(MyCompaniesActionTypes.GET_MY_COMPANIES_SUCCESS, companies);
export const getMyCompaniesError = (error: GiroWebappError) => action(MyCompaniesActionTypes.GET_MY_COMPANIES_ERROR, error);